import { Directive, Input, HostListener } from "@angular/core";

@Directive({
	selector: "input[obgTrimWhitespaceToHyphen]",
})
export class TrimWhitespaceToHyphenDirective {
	@Input() obgTrimWhitespaceToHyphen = false;

	@HostListener("input", ["$event"])
	onInput(event: Event) {
		if (this.obgTrimWhitespaceToHyphen) {
			const input = event.target as HTMLInputElement;
			input.value = input.value.replace(/\s/g, "-");
		}
	}
}
